import { Loader } from 'lucide-react';

import { cn } from '../../utils/cn';

export function ChartLoader({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'inset-0 flex items-center justify-center bg-white/70 backdrop-blur-sm',
        className,
      )}
    >
      <div className="flex items-center gap-2 rounded-lg bg-white px-3 py-2 shadow-sm">
        <Loader className="size-4 animate-spin" />
        <span className="text-sm text-zinc-600">Loading chart...</span>
      </div>
    </div>
  );
}
